




































































































































































import {Vue, Component, Prop} from 'vue-property-decorator';
import RadioElement from '@/components/common/RadioElement.vue';
import ReportLayer from '@/components/product/review/ReportLayer.vue';
import {ncpPopup} from '@/utils/ncp';
import { convertProductUri } from '@/utils/commonUtils';

@Component({
  components: {RadioElement, ReportLayer}
})
export default class ReviewInfo extends Vue {
  @Prop()
  private reviewInfo!: any;
  @Prop()
  private type!: string;

  private get reviewExtraJson() {
    if (this.reviewInfo.reviewDetail.extraJson) {
      let resExtraList = [];
      let tempJson = JSON.parse(this.reviewInfo.reviewDetail.extraJson);
      if (!tempJson.reviewSource) {
        for (const [key, value] of Object.entries(tempJson)) {
          resExtraList.push({key, value});
        }
      }
      return resExtraList;
    }
  }

  private get bestReviewLabel() {
    if (this.reviewInfo.reviewDetail) {
      return this.reviewInfo.reviewDetail.bestReviewYn === 'Y' ? this.$t('PRODUCT_REVIEW_REVIEW_TYPE_BEST') : this.$t('PRODUCT_REVIEW_REVIEW_TYPE_NORMAL');
    }
  }

  // 작성자
  private openMemberPop() {
    ncpPopup(`/member/popup/crm/${this.reviewInfo.reviewDetail.register.memberNo}`, window.$t('PRODUCT_REVIEW_POP_CRM'), 1100, 980);
  }

  // 상품번호
  private productUrl = '';
  private openMallProduct() {
    window.open(this.productUrl, '_blank');
  }

  // 신고
  private showReportLayer = false;
  private reportList: any[] = [];
  private async openReportLayer() {
    if (this.reviewInfo.reviewDetail.reportCnt > 0) {
      let request = {
        pathParams: {
          reviewNo: this.reviewInfo.reviewDetail.no
        }
      };
      let {data} = await this.$api.getReviewsReviewNoReports(request);
      this.reportList = data;
      this.showReportLayer = true;
    }
  }

  // 전시상태
  private displayStatusTypes = {
    name: 'displayStatusType',
    data: [
      {
        id: 'displayStatusType_DISPLAY',
        value: 'DISPLAY',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_DISPLAY'
      },
      {
        id: 'displayStatusType_BLIND',
        value: 'BLIND',
        dispaly: 'PRODUCT_REVIEW_DISPLAY_STATUS_TYPE_BLIND'
      }
    ]
  };

  // 상품평 구분
  private bestYnType = {
    name: 'bestYnType',
    data: [
      {
        id: 'bestYnType_N',
        value: 'N',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_NORMAL'
      },
      {
        id: 'bestYnType_Y',
        value: 'Y',
        dispaly: 'PRODUCT_REVIEW_REVIEW_TYPE_BEST'
      }
    ]
  };

  private async created() {
    let {data} = await this.$api.getProductsConfiguration({params: {mallNo: this.reviewInfo.reviewDetail.mallNo}});
    this.productUrl = convertProductUri(data.productDetailUrl, this.reviewInfo.reviewDetail.productNo)
  }
}
